import m from "mithril";
import { formatRupiah, formatDate } from "../../utils.js";
import PaginatedExpandableTable from "./PaginatedExpandableTable.js";

const DaftarPinjamanList = {
    view: function (vnode) {
        const { state } = vnode.attrs;

        return m(PaginatedExpandableTable, {
            state,
            columns: [
                { label: "No. Reg", cell: (item) => item.no_reg || "-" },
                { label: "Nama Nasabah", cell: (item) => item.nama_nasabah },
                { label: "Jml Pinjaman", align: "center", cell: (item) => item.loan_count },
                { label: "Total Disalurkan", align: "right", cell: (item) => formatRupiah(item.total_disbursed) },
                {
                    label: "Sisa Pokok", align: "right",
                    cellClass: "font-bold text-gray-900 dark:text-white",
                    cell: (item) => formatRupiah(item.total_outstanding)
                },
                { label: "Angsuran Berikut", align: "right", cell: (item) => formatDate(item.next_due_date) }
            ],
            renderDetail: (loans) =>
                m("table", { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-md" }, [
                    m("thead", { class: "bg-gray-100 dark:bg-gray-800" }, [
                        m("tr", [
                            m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "No. Pencairan"),
                            m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Produk"),
                            m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Tgl Cair"),
                            m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Tenor"),
                            m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Jml Pinjaman"),
                            m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Sisa Pokok"),
                            m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Angsuran Berikut")
                        ])
                    ]),
                    m("tbody", { class: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" },
                        loans.length === 0 ?
                            m("tr", [
                                m("td", { colspan: 7, class: "px-4 py-2 text-sm text-gray-500 text-center" }, "Tidak ada pinjaman aktif")
                            ]) :
                            loans.map(loan =>
                                m("tr", [
                                    m("td", { class: "px-4 py-2 text-sm font-mono text-gray-700 dark:text-gray-300" }, loan.disbursement_no),
                                    m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300" }, loan.product_name || "-"),
                                    m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300" }, formatDate(loan.disbursement_date)),
                                    m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300" }, loan.approvedTenor ? `${loan.approvedTenor} bln` : "-"),
                                    m("td", { class: "px-4 py-2 text-sm text-right text-gray-700 dark:text-gray-300" }, formatRupiah(loan.disbursement_amount)),
                                    m("td", { class: "px-4 py-2 text-sm text-right font-medium text-gray-900 dark:text-white" }, formatRupiah(loan.total_outstanding)),
                                    m("td", { class: "px-4 py-2 text-sm text-right text-gray-700 dark:text-gray-300" }, formatDate(loan.next_due_date))
                                ])
                            )
                    )
                ]),
            filterBar: (state) => m("div", { class: "flex justify-between items-center mb-6" }, [
                m("div", { class: "flex space-x-2" }, [
                    m("input", {
                        type: "text",
                        class: "px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                        placeholder: "Cari nasabah...",
                        value: state.filters.search || "",
                        oninput: (e) => { state.filters.search = e.target.value; },
                        onkeypress: (e) => { if (e.key === 'Enter') state.refresh(); }
                    }),
                    m("button", {
                        class: "px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500",
                        onclick: () => state.refresh()
                    }, "Cari")
                ])
            ]),
            emptyText: "Tidak ada data pinjaman"
        });
    }
};

export default DaftarPinjamanList;
